interface StepIndicatorProps {
  step: number;
  currentStep: number;
  onClick: () => void;
  disabled: boolean;
}

const StepIndicator = ({ step, currentStep, onClick, disabled }: StepIndicatorProps) => {
  const getStepStyle = () => {
    if (step === currentStep) {
      return "bg-black text-white";
    }
    if (step < currentStep) {
      return "bg-gray-800 text-white cursor-pointer";
    }
    return "bg-gray-100 text-gray-400";
  };

  return (
    <div
      className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors ${getStepStyle()} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      onClick={() => !disabled && onClick()}
      role="button"
      tabIndex={disabled ? -1 : 0}
    >
      {step}
    </div>
  );
};

export default StepIndicator;